import { css } from '@compiled/react';

import { iconMapping } from './icon-mapping.tsx';

export interface IconProps {
	name: string;
	size: 'small' | 'medium';
}

export const Icon = (props: IconProps) => {
	const { name, size } = props;
	if (!name) {
		return <GlyphIcon size={size} name="TaskInProgressIcon" />;
	}

	const mapping = iconMapping[name];

	if (mapping?.version === 'glyph') {
		return <GlyphIcon {...props} />;
	}

	return <CoreIcon {...props} />;
};

const iconWrapperSmallCss = css({
	width: '24px',
	height: '24px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

const iconWrapperMediumCss = css({
	width: '32px',
	height: '32px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

const CoreIcon = (props: IconProps) => {
	const { name, size } = props;
	const BaseIcon = iconMapping[name]?.component;
	return (
		<span
			css={[size === 'small' && iconWrapperSmallCss, size === 'medium' && iconWrapperMediumCss]}
		>
			<BaseIcon icon={name} />
		</span>
	);
};

const GlyphIcon = (props: IconProps) => {
	const { name, size } = props;
	const BaseGlyphIcon = iconMapping[name]?.component;
	return (
		<span
			css={[
				size === 'small' && iconWrapperSmallCss,
				size === 'small' && glyphIconWrapperSmallCss,
				size === 'medium' && iconWrapperMediumCss,
				size === 'medium' && glyphIconWrapperMediumCss,
			]}
		>
			<BaseGlyphIcon icon={name} size={size} />
		</span>
	);
};

const glyphIconWrapperSmallCss = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& svg': {
		height: '18px !important',
	},
});
const glyphIconWrapperMediumCss = css({
	paddingBlockStart: '1.5px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& svg': {
		height: '20px !important',
	},
});
